import { computed, ref, type Ref } from "vue";
import { showPortalButtonKey } from "~/utils/constants";

function readPortalLoginEnabled(): boolean {
  return localStorage.getItem(showPortalButtonKey) === "true";
}

function writePortalLoginEnabled(enabled: boolean) {
  if (enabled) {
    localStorage.setItem(showPortalButtonKey, "true");
  } else {
    localStorage.removeItem(showPortalButtonKey);
  }
}

function normalizePortalLoginStorage() {
  const value = localStorage.getItem(showPortalButtonKey);
  if (value !== null && value !== "true") {
    localStorage.removeItem(showPortalButtonKey);
  }
}

normalizePortalLoginStorage();

const portalLoginEnabled = ref(readPortalLoginEnabled());

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === showPortalButtonKey) {
      portalLoginEnabled.value = event.newValue === "true";
    }
  });
}

export function useShowPortalLoginButton(): Ref<boolean> {
  return computed({
    get: () => portalLoginEnabled.value,
    set: (enabled: boolean) => {
      portalLoginEnabled.value = enabled;
      writePortalLoginEnabled(enabled);
    },
  });
}
